import { render } from "./WorldPage.vue?vue&type=template&id=ff4fd2b2&scoped=true"
import script from "./WorldPage.vue?vue&type=script&lang=js"
export * from "./WorldPage.vue?vue&type=script&lang=js"

import "./WorldPage.vue?vue&type=style&index=0&id=ff4fd2b2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff4fd2b2"]])

export default __exports__